import { css, cva, cx } from '../../../../styled-system/css'

const navbarRecipe = cva({
    base: {
        display: 'flex!',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        left: '[50%]',
        width: 'full',
        height: '[32px]',
        paddingX: '3',
        backgroundColor: 'gray.50',
        transform: '[translateX(-50%)]',
        zIndex: 1000,
        fontSize: '[14px]',
        lineHeight: '[20px]',
        borderBottom: '[1px solid #cccccc]',
    },
    variants: {
        variant: {
            default: {
                width: 'full',
            },
            'news-with-slider': {
                width: {
                    base: 'full',
                    md: '[750px]',
                    xl: '[1080px]',
                },
            },
            news: {
                width: {
                    base: 'full',
                    xl: '[1200px]',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'default',
    },
})

interface NavbarProps {
    className?: string
    variant?: 'default' | 'news-with-slider' | 'news'
}

export function Navbar({ children, className, variant }: React.PropsWithChildren<NavbarProps>) {
    return <nav className={cx(navbarRecipe({ variant }), className)}>{children}</nav>
}

function NavbarLinkList({ children, className }: React.PropsWithChildren<{ className?: string }>) {
    return (
        <ul
            className={cx(
                css({
                    display: { md: 'flex' },
                    alignItems: 'center',
                    marginTop: '0', // reset ul
                    marginBottom: '0', // reset ul
                    padding: '0', // reset ul
                    listStyle: 'none', // reset ul
                }),
                className
            )}
        >
            {children}
        </ul>
    )
}

Navbar.LinkList = NavbarLinkList
